const ListRenderState = {
    shouldNotRender: 1,
    shouldRenderEmptyMessage: 2,
    shouldRenderList: 3
};

export default ListRenderState;